// Glyphs from docs/design/suite-side-nav.html, plus a few drawn in the same
// 24px grid and stroke weight for views the mockup doesn't cover. Rendered once
// as a hidden sprite; <Icon> references a symbol by name.
export function IconSprite() {
  const line = { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" };
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
      <symbol id="i-search" viewBox="0 0 24 24" {...line} strokeWidth="1.8"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></symbol>
      <symbol id="i-chev" viewBox="0 0 24 24" {...line} strokeWidth="2"><path d="m6 9 6 6 6-6" /></symbol>
      <symbol id="i-clock" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></symbol>
      <symbol id="i-chat" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1.1-4.4A8 8 0 1 1 21 12z" /></symbol>
      <symbol id="i-code" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="m8 8-4 4 4 4M16 8l4 4-4 4M13.5 5l-3 14" /></symbol>
      <symbol id="i-chart" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="M3 20h18M6 20v-6M11 20V6M16 20v-9" /></symbol>
      <symbol id="i-list" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" /></symbol>
      <symbol id="i-refresh" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="M20 11a8 8 0 0 0-14.3-4.9L4 8" /><path d="M4 3v5h5" /><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16" /><path d="M20 21v-5h-5" /></symbol>
      <symbol id="i-alert" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="M12 3 2 20h20z" /><path d="M12 9v5M12 17h.01" /></symbol>
      <symbol id="i-menu" viewBox="0 0 24 24" {...line} strokeWidth="1.8"><path d="M4 6h16M4 12h16M4 18h16" /></symbol>
      <symbol id="i-logout" viewBox="0 0 24 24" {...line} strokeWidth="1.6"><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" /><path d="m10 17-5-5 5-5" /><path d="M5 12h11" /></symbol>
      <symbol id="i-back" viewBox="0 0 24 24" {...line} strokeWidth="1.8"><path d="M19 12H5M11 18l-6-6 6-6" /></symbol>
    </svg>
  );
}

export function Icon({ name, size = 19, className }) {
  return (
    <svg className={className} width={size} height={size} aria-hidden="true" focusable="false">
      <use href={`#i-${name}`} />
    </svg>
  );
}
